module.exports = __webpack_public_path__ + "static/adjustable-base-2-reading-6048301094ccd25ae65c807982803f49.webp";